export const statusMapper = {
  'KYC':'70',
  'RISK':'70',
  'DIGITAL SIGNATURE':'80',
  'MID CREATION':'90',
};

export const kycResponse = {
  event: 'KYC',
  caseId: '5001m000008LixcAAC',
  virtualStoreID: '0011m00000fmW0dAAE',
  UATMID: '13452',
  entityType: '9',
  KYCStatus: 'Rejected',
  RiskStatus: 'Rejected',
  Comment: 'Case is Rejected due to invalid Documents',
  Document: [
    {
      docType: 'Proof of Identity',
      docuSubType: 'Pan Card',
      status: 'Rejected',
      RejectionReason: 'Image is not clear',
      Solution:
        'Re-upload the Document with Signature of Authorized Signatory & Company Stamp',
      Remarks: 'Reupload Document',
    },
    {
      docType: 'Business Legality Proof',
      docuSubType: 'GST Certificate',
      status: 'Success',
      RejectionReason: null,
      Solution: null,
      Remarks: 'Document verified',
    },
  ],
};

export const ProfileMessageMapping = {
  '10': 'Welcome to Plural! Complete your KYC to start accepting payments.',
  '20': 'Complete your KYC to start accepting payments.',
  '25': 'Complete your KYC to start accepting payments.',
  '30': 'Complete your KYC to start accepting payments.',
  '35': 'Complete your KYC to start accepting payments.',
  '40': 'Complete your KYC to start accepting payments.',
  '45': 'Complete your KYC to start accepting payments.',
  '50': 'Pending for KYC Approval.',
  '70': 'KYC has been successfully approved.',
  '80': 'Agreement has been sent to your email for digital signature.',
  '90': 'Thank you for signing the agreement. We are setting up your account.',
  '100': 'Congratulations, your Plural account has been activated. You can start accepting payment for active payment modes.'
};

export const valueKeyMap = {
  'Proof of Identity': 'PROOF_OF_IDENTITY',
  'Business Legality Proof': 'BUSINESS_LEGALITY_PROOF',
  'Proof of Business Address': 'PROOF_OF_BUSINESS_ADDRESS',
  'Bank Account Details': 'BANK_ACCOUNT_DETAILS',
  'PAN Card': 'INDIVIDUAL_PAN',
  'Aadhaar card': 'AADHAAR',
  Passport: 'PASSPORT',
  'Voter ID card': 'VOTER_ID',
  'Driving License': 'DRIVING_LICENSE',
  'Trade License issued by the local authority in the name of the proprietor containing address of the firm.':
    'TRADE_LICENSE',
  'Shop & Establishment Certificate issued by a Civic Authority':
    'SE_CERTIFICATE',
  'GST Certificate': 'GST',
  'Cancelled Cheque': 'CANCELLED_CHEQUE',
  'Bank Statement': 'BANK_STATEMENT',
  'Passbook copy': 'PASSBOOK',
  'Bank Verification Letter': 'BANK_VERIFICATION_LETTER',
};

export const citiMerchantIds = [ '113484' ];
